import { createRouter, createWebHistory } from 'vue-router';

import Navigation from '../views/Navigation.vue';

import VideoPageLinda1 from '@/views/Linda_page1.vue';
import VideoPageLinda2 from '../views/Linda_page2.vue';
import VideoPageLinda3 from '../views/Linda_page3.vue';
import VideoPageLinda4 from '@/views/Linda_page4.vue';
import VideoPageLinda5 from '../views/Linda_page5.vue';
import VideoPageLinda6 from '../views/Linda_page6.vue';
import VideoPageLinda7 from '../views/Linda_page7.vue';
import VideoPageLinda8 from '../views/Linda_page8.vue';


import QR_Redirect from '../views/QR_Redirect.vue';

const routes = [
  {
    path: '/',
    name: 'Navigation',
    component: Navigation,
  },
  {
    path: '/page-one',
    name: 'Linda_page1',
    component: VideoPageLinda1,
  },
  {
    path: '/page-two',
    name: 'Linda_page2',
    component: VideoPageLinda2,
  },
  {
    path: '/page-three',
    name: 'Linda_page3',
    component: VideoPageLinda3,
  },
  {
    path: '/page-four',
    name: 'Linda_page4',
    component: VideoPageLinda4,
  },
  {
    path: '/page-five',
    name: 'Linda_page5',
    component: VideoPageLinda5,
  },
  {
    path: '/page-six',
    name: 'Linda_page6',
    component: VideoPageLinda6,
  },
  {
    path: '/page-seven',
    name: 'Linda_page7',
    component: VideoPageLinda7,
  },
  {
    path: '/page-eight',
    name: 'Linda_page8',
    component: VideoPageLinda8,
  },
  {
    path: '/QRredirect',
    name: 'QR_Redirect',
    component: QR_Redirect,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;